import { SecondaryButton } from '@joor/design-system'

import { formatNameWithCode } from 'utils/formatters'
import { fromGlobalId } from 'utils/transformations/graphql'

import LoaderOverlay from 'components/Loader/LoaderOverlay'

import styles from './NoAccessAccountPage.module.css'
import {
  useSetSelectedAccount,
  useUserAccounts,
} from 'features/Navbar/NavbarRevamp/components/AccountsDropdown/accountsDropdown.hooks'

const NoAccessAccountPage = () => {
  const { userAccounts, loading } = useUserAccounts()
  const { setSelectedAccount } = useSetSelectedAccount()

  if (loading) {
    return <LoaderOverlay />
  }

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>You cannot use this account</h1>
      <p className={styles.info}>
        You don&apos;t have permission to act on this account.
        {userAccounts.length > 0
          ? ' Switch to another of your accounts to continue.'
          : ''}
      </p>
      {userAccounts.length > 0 && (
        <ul className={styles.accountList}>
          {userAccounts.map((account) => (
            <li key={account.id}>
              <SecondaryButton onClick={() => setSelectedAccount(account.id)}>
                {formatNameWithCode(account.name, fromGlobalId(account.id).id)}
              </SecondaryButton>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default NoAccessAccountPage
